import StockThumb1 from "../img/photos/thumbs/stocks-1.jpg";
import StockThumb2 from "../img/photos/thumbs/stocks-2.jpg";
import StockThumb3 from "../img/photos/thumbs/stocks-3.jpg";
import StockThumb4 from "../img/photos/thumbs/stocks-4.jpg";
import StockThumb5 from "../img/photos/thumbs/stocks-5.jpg";
import StockThumb6 from "../img/photos/thumbs/stocks-6.jpg";
import StockThumb7 from "../img/photos/thumbs/stocks-7.jpg";
import StockThumb8 from "../img/photos/thumbs/stocks-8.jpg";
import StockThumb9 from "../img/photos/thumbs/stocks-9.jpg";
import StockThumb10 from "../img/photos/thumbs/stocks-10.jpg";
import StockThumb11 from "../img/photos/thumbs/stocks-11.jpg";
import StockThumb12 from "../img/photos/thumbs/stocks-12.jpg";
import StockThumb13 from "../img/photos/thumbs/stocks-13.jpg";
import StockThumb14 from "../img/photos/thumbs/stocks-14.jpg";
import StockThumb15 from "../img/photos/thumbs/stocks-15.jpg";

import Stock1 from "../img/photos/stocks/stocks-1.jpg";
import Stock2 from "../img/photos/stocks/stocks-2.jpg";
import Stock3 from "../img/photos/stocks/stocks-3.jpg";
import Stock4 from "../img/photos/stocks/stocks-4.jpg";
import Stock5 from "../img/photos/stocks/stocks-5.jpg";
import Stock6 from "../img/photos/stocks/stocks-6.jpg";
import Stock7 from "../img/photos/stocks/stocks-7.jpg";
import Stock8 from "../img/photos/stocks/stocks-8.jpg";
import Stock9 from "../img/photos/stocks/stocks-9.jpg";
import Stock10 from "../img/photos/stocks/stocks-10.jpg";
import Stock11 from "../img/photos/stocks/stocks-11.jpg";
import Stock12 from "../img/photos/stocks/stocks-12.jpg";
import Stock13 from "../img/photos/stocks/stocks-13.jpg";
import Stock14 from "../img/photos/stocks/stocks-14.jpg";
import Stock15 from "../img/photos/stocks/stocks-15.jpg";

import OppoThumb from "../img/photos/thumbs/oppo.jpg";
import SonyThumb from "../img/photos/thumbs/sony-alpha.jpg";
import OretThumb from "../img/photos/thumbs/oret-studio.jpg";
import StromtechThumb from "../img/photos/thumbs/stromtech.jpg";
import UniversalThumb from "../img/photos/thumbs/universal-studio.jpg";
import WandererThumb from "../img/photos/thumbs/wanderer-bracelets.jpg";
import TourismThumb from "../img/photos/thumbs/tourism-boards.jpg";

import Profile from "../img/photos/wahyu.jpg";

import Omnia from "../img/clients/omnia.svg";
import QatarAirways from "../img/clients/qatar-airways.svg";
import AirAsia from "../img/clients/airasia.png";
import SingaporeAirlines from "../img/clients/singapore-airlines.png";
import Traveloka from "../img/clients/traveloka.png";
import Tokopedia from "../img/clients/tokopedia.png";
import Starwood from "../img/clients/starwood.png";
import Grindelwald from "../img/clients/grindelwald.svg";
import Graubuenden from "../img/clients/graubuenden.svg";
import IndonesiaTourism from "../img/clients/indonesia-tourism-board.jpg";
import MalaysiaTourism from "../img/clients/malaysia-tourism.png";
import TaiwanTourism from "../img/clients/taiwan-tourism.png";
import WATourism from "../img/clients/western-australia-tourism.png";
import NZTourism from "../img/clients/nz-tourism.svg";
import Oppo from "../img/clients/oppo.svg";
import SonyAlpha from "../img/clients/sony-alpha.svg";
import Unilever from "../img/clients/unilever.svg";
import HP from "../img/clients/hp.svg";
import Starbucks from "../img/clients/starbucks.svg";

export const data = {
  portfolios: [
    {
      title: "1",
      thumbSrc: StockThumb1,
      src: Stock1
    },
    {
      title: "2",
      thumbSrc: StockThumb2,
      src: Stock2
    },
    {
      title: "3",
      thumbSrc: StockThumb3,
      src: Stock3
    },
    {
      title: "4",
      thumbSrc: StockThumb4,
      src: Stock4
    },
    {
      title: "5",
      thumbSrc: StockThumb5,
      src: Stock5
    },
    {
      title: "6",
      thumbSrc: StockThumb6,
      src: Stock6
    },
    {
      title: "7",
      thumbSrc: StockThumb7,
      src: Stock7
    },
    {
      title: "8",
      thumbSrc: StockThumb8,
      src: Stock8
    },
    {
      title: "9",
      thumbSrc: StockThumb9,
      src: Stock9
    },
    {
      title: "10",
      thumbSrc: StockThumb10,
      src: Stock10
    },
    {
      title: "11",
      thumbSrc: StockThumb11,
      src: Stock11
    },
    {
      title: "12",
      thumbSrc: StockThumb12,
      src: Stock12
    },
    {
      title: "13",
      thumbSrc: StockThumb13,
      src: Stock13
    },
    {
      title: "14",
      thumbSrc: StockThumb14,
      src: Stock14
    },
    {
      title: "15",
      thumbSrc: StockThumb15,
      src: Stock15
    }
  ],
  commissions: [
    {
      link: "oppo-indonesia",
      title: "OPPO INDONESIA",
      thumb: OppoThumb,
      hiResThumb: "",
      photos: []
    },
    {
      link: "sony-alpha-indonesia",
      title: "SONY ALPHA INDONESIA",
      thumb: SonyThumb,
      photos: []
    },
    {
      link: "tourism-boards",
      title: "TOURISM BOARDS",
      thumb: TourismThumb,
      hiResThumb: "",
      photos: []
    },
    {
      link: "universal-studio-japan",
      title: "UNIVERSAL STUDIO JAPAN",
      thumb: UniversalThumb,
      hiResThumb: "",
      photos: []
    },
    {
      link: "stromtech",
      title: "STROMTECH",
      thumb: StromtechThumb,
      hiResThumb: "",
      photos: []
    },
    {
      link: "wanderer-bracelets",
      title: "WANDERER BRACELETS",
      thumb: WandererThumb,
      hiResThumb: "",
      photos: []
    },
    {
      link: "oret-studio",
      title: "ORET STUDIO",
      thumb: OretThumb,
      hiResThumb: "",
      photos: []
    }
  ],
  profile: Profile,
  clients: [
    Omnia,
    QatarAirways,
    AirAsia,
    SingaporeAirlines,
    Traveloka,
    Tokopedia,
    Starwood,
    IndonesiaTourism,
    MalaysiaTourism,
    TaiwanTourism,
    Grindelwald,
    Graubuenden,
    WATourism,
    NZTourism,
    Oppo,
    SonyAlpha,
    Unilever,
    HP,
    Starbucks
  ]
};

export default data;
